import { ImageAdd } from 'blaze-ui/icons'
import Styles from './Link.module.scss'

export const EmptyState = () => {
  return (
    <div className={Styles.emptyState}>
      <ImageAdd size={36} color="var(--dark-10)" />
    </div>
  )
}
